import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import MainTitle from '@/components/title/MainTitle.vue';
import { Options, Vue } from 'vue-class-component';
import store from '@/store';
import { router } from "@/router";
import AuthLinksTable from '@/components/authLink/AuthLinksTable.vue';
import AuthLinkForm from "@/views/authLink/AuthLinkForm.vue";
import CenterTop from "@/components/layout/CenterTop.vue";
var AuthItemList = /*#__PURE__*/function (_Vue) {
  function AuthItemList() {
    var _this;
    _classCallCheck(this, AuthItemList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AuthItemList, [].concat(args));
    _defineProperty(_this, "errorMsg", '');
    _defineProperty(_this, "toggleAuthLinkFormDialog", false);
    return _this;
  }
  _inherits(AuthItemList, _Vue);
  return _createClass(AuthItemList, [{
    key: "mounted",
    value: function mounted() {
      if (!this.isAuthItem) {
        router.push({
          name: 'HomePage'
        });
      }
    }
  }, {
    key: "isCreateAuthLink",
    get: function get() {
      return store.getters.isAuthLinkCreateAivailable;
    }
  }, {
    key: "isAuthItem",
    get: function get() {
      return store.getters.isAuthItemAvailable;
    }
  }]);
}(Vue);
AuthItemList = __decorate([Options({
  components: {
    AuthLinksTable: AuthLinksTable,
    CenterTop: CenterTop,
    MainTitle: MainTitle,
    AuthLinkForm: AuthLinkForm
  }
})], AuthItemList);
export default AuthItemList;